var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('draggable',{attrs:{"animation":"200","drag-class":"t-opacity-0","handle":".cxm-Dots","list":_vm.list}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }